<template>
  <button
    type="button"
    class="btn btn-link btn-sm text-white"
    :aria-label="t('openMessages')"
    :title="t('openMessages')"
    @click="onClickAdd"
  >
    <span class="icon-wrapper">
      <i class="bi bi-envelope-fill" />
      <i
        v-if="localHasUnread"
        class="bi bi-circle-fill text-danger badge-icon"
      />
    </span>
  </button>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Messages from '@/views/messages/list.vue'
import { useModalStack } from '@/stores/modalstack'
import { useIntervalFn } from '@vueuse/core'
import { useApi } from '@/composables/api'
import config from '@/config'

const interval = Number(config.VITE_STATUS_INTERVAL ?? 30000)
const { t } = useI18n()
const { model: hasUnread, refresh: rawRefresh } = useApi({
  url: 'current_status',
  pick: d => d.has_unread,
})
const localHasUnread = ref(false)

const refresh = async () => {
  try {
    await rawRefresh()
    localHasUnread.value = !!hasUnread.value
  } catch {
    // Фоновый опрос current_status не должен валить UI (NetworkError при долгой истории и т.п.)
  }
}
if (interval > 0) {
  useIntervalFn(refresh, interval, { immediate: true, immediateCallback: true })
}
const { push: openModal } = useModalStack()

function onClickAdd() {
  openModal({
    component: Messages,
    props: {
      class: 'modal-messages',
      headerText: t('title'),
      localHasUnread,
    },
  })
}
</script>
<i18n>
{
  "ru": {
    "title": "Список сообщений",
    "openMessages": "Открыть сообщения"
  },
  "en": {
    "title": "Message list",
    "openMessages": "Open messages"
  }
}
</i18n>
<style scoped>
.icon-wrapper {
  position: relative;
  display: inline-block;
}

.badge-icon {
  position: absolute;
  top: 0.05rem;
  right: -0.3rem;
  font-size: 0.4rem;
  z-index: 2;
  border-radius: 50%;
  padding: 0.1rem;
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
